/* eslint-disable no-undef */
import moment from 'moment'

export const isValidCardNumber = (values, value) => {
  switch (values.payment_provider) {
    // case 'PayU':
    //   return payU.validateCard(value)
    // case 'SrPago':
    //   return SrPago.card.validateCardNumber(value)

    default:
      return Conekta.card.validateNumber(value)
  }
}

export const isValidExpirationDate = (expirationMonth, expirationYear, paymentProvider) => {
  if (paymentProvider === 'SrPago') {
    if (!(expirationMonth <= 12 && expirationMonth > 0)) {
      return false
    }

    return !!SrPago.card
      .validateExpirationDate(Number(expirationMonth), Number(expirationYear))
  }

  return !!Conekta.card.validateExpirationDate(Number(expirationMonth), Number(expirationYear))
}

export const isValidExpMonth = (values, value) => value <= 12 && value > 0

export const isValidCVV = (values, value) => {
  if (values.payment_provider === 'SrPago') {
    return SrPago.card.validateCVV(value)
  }

  return Conekta.card.validateCVC(value)
}

export const ValidateDatePayU = (month, year) => {
  const expirationDate = moment(`${month}-${year}`, 'MM-YYYY')
  const currentYear = moment().year()

  if (expirationDate.year() === currentYear) {
    return expirationDate.month() > moment().month()
  }

  return expirationDate.year() > currentYear
}

export const isValidAmount = (value, subtotal) => (value <= subtotal)



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/Validations.js